import { FieldSelect, FieldText } from '@dixa/lib-shared-habla';
import * as React from 'react';
import { Field } from 'redux-form';
import { length, required } from 'redux-form-validators';

import { LanguageCustomizationForm } from '../../types';

import style from './index.module.scss';

const csatMessengerMainQuestionMaxLength = { max: 256 };

export const CustomizationFormView: React.FunctionComponent = () => {
  return (
    <section className={style.root}>
      <Field
        required
        name={LanguageCustomizationForm.Fields.lookAndFeel}
        helpIcon={{
          text: 'Choose the score look and feel',
        }}
        validate={[required()]}
        placeholder="Look and feel"
        label="Look and feel"
        component={FieldSelect}
        items={[
          { id: 'emojis', name: 'Emoji' },
          { id: 'stars', name: 'Star' },
          { id: 'numbers', name: 'Number' },
        ]}
        disabledItems={['stars', 'numbers']}
      />

      <Field
        required
        name={LanguageCustomizationForm.Fields.ratingQuestion}
        validate={[required(), length(csatMessengerMainQuestionMaxLength)]}
        placeholder="Main question"
        label="Main question"
        component={FieldText}
      />

      <Field
        required
        name={LanguageCustomizationForm.Fields.followupQuestion}
        validate={[required()]}
        placeholder="Followup question"
        label="Followup question"
        component={FieldText}
      />

      <Field
        required
        name={LanguageCustomizationForm.Fields.ratingPlaceholder}
        validate={[required()]}
        placeholder="Comment placeholder text"
        label="Placeholder"
        component={FieldText}
      />

      <Field
        required
        name={LanguageCustomizationForm.Fields.thankyouMessage}
        validate={[required()]}
        placeholder="Thank you message"
        label="Thank you message"
        component={FieldText}
      />
    </section>
  );
};
